export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TEXT: 'text',
  DANGER: 'danger'
}
